import { PageContentContainer } from 'components';

export const Retail = () => {
  return <PageContentContainer>Retail page in progress...</PageContentContainer>;
};